'use client'

import type { SwitcherEmptyStateProps } from '@maestro/commerce-blocks/components/switcher/switcher.types'

import classNames from 'classnames'
import NextImage from 'next/image'

export default function SwitcherEmptyState(props: SwitcherEmptyStateProps) {
  const { title, description, className } = props

  return (
    <div
      className={classNames('empty-switcher', className)}
      data-testid="empty-switcher"
    >
      <NextImage
        className="empty-switcher__image"
        src="/assets/icons/icon-no-results.svg"
        width={147}
        height={108}
        alt="" // empty alt to hide image from screen readers
        role="presentation"
        loading="lazy"
      />
      <div className="empty-switcher__description">
        <div className="h5 empty-switcher__title">{title}</div>
        {description}
      </div>
    </div>
  )
}
